
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomahabaleshwarswift() {



    const cardData =
    {
        keyword: ' Pune to Mahabaleshwar Swift Dzire Cabs',
        heading: 'Prince Cabs: Pune to Mahabaleshwar Swift Dzire Cabs',
        headingDescription: 'Prince Cabs offers comfortable and budget-friendly Pune to Mahabaleshwar Swift Dzire Cabs, perfect for family vacations, weekend getaways, and sightseeing tours. Our well-maintained Swift Dzire cars are fuel-efficient and provide a smooth ride through the scenic Western Ghats. With professional chauffeurs, timely pickups, and flexible booking options, we ensure a hassle-free journey from Pune to Mahabaleshwar. Experience reliability, affordability, and convenience with Prince Cabs’ trusted Swift Dzire cab service to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Prince Cabs',

"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is one of Mahabaleshwar’s most visited attractions, surrounded by lush greenery and hills. Visitors enjoy boating, horse riding, and lakeside strolls. Food stalls serve local treats like roasted corn and strawberries with cream. The lake becomes especially lively during weekends and holidays. In the evening, the cool breeze and sunset views create a romantic setting. Venna Lake is the heart of Mahabaleshwar’s tourist experience."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a famous landmark, celebrated for its strawberry products and food court. Tourists enjoy fresh strawberry milkshakes, ice creams, and the signature strawberries with cream. The annual Strawberry Festival held here attracts large crowds. The landscaped lawns, kids’ play zones, and retail shop selling jams, syrups, and chocolates make it a family favorite. It blends food, leisure, and greenery. Mapro Garden is a sweet stop on every Mahabaleshwar trip."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, built by Chhatrapati Shivaji Maharaj in 1656, is a historic site near Mahabaleshwar. It is renowned for the famous battle where Shivaji defeated Afzal Khan. The fort features ancient temples, massive walls, and viewing points offering breathtaking valley vistas. Trekkers enjoy the moderately challenging climb to the top. It is both a historical landmark and a scenic getaway. Pratapgad showcases Maratha valor and architectural brilliance."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point, also called Sunrise Point, is the highest point in Mahabaleshwar at 1,439 meters. It offers a 360-degree view of the surrounding valleys and hills. Early risers are rewarded with spectacular sunrise views. The three observation towers provide perfect photography angles. The site is equally enchanting during sunset and stargazing nights. Wilson Point is a must-visit for nature lovers and photographers."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a natural rock formation that resembles an elephant’s trunk, making it one of Mahabaleshwar’s most photographed spots. The viewpoint offers panoramic views of the Sahyadri valleys. Mist and cool breeze add to the charm, especially in monsoon. Couples and families love its tranquil setting. Photographers capture dramatic landscapes here. It is a highlight of Mahabaleshwar’s sightseeing circuit."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is famously called the ‘Queen of Points,’ offering spectacular views of the Savitri River valley. Visitors are fascinated by the optical illusion here where light objects thrown down appear to float up. The point is surrounded by smaller attractions like Echo Point and Tiger Spring. Trekkers and nature lovers frequent this spot for its scenic beauty. Arthur’s Seat is one of the most popular viewpoints in Mahabaleshwar."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a breathtaking natural wonder located near Mahabaleshwar. Cascading from a height of about 600 feet, it looks majestic during monsoon. Visitors can view the falls safely from designated platforms. The surrounding forest enhances its scenic beauty. Smaller falls nearby allow closer access for tourists. Lingmala is a paradise for photographers and nature enthusiasts. Its roaring waters create a refreshing ambiance."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "The Mahabaleshwar Temple, dedicated to Lord Shiva, is an ancient shrine built in Hemadpanti architectural style. It houses a swayambhu Shiva linga, making it a highly revered pilgrimage site. The temple is over 800 years old and has deep spiritual significance. Pilgrims and tourists alike admire its simplicity and heritage value. Surrounded by scenic hills, the temple exudes divine serenity. It adds spiritual depth to Mahabaleshwar’s attractions."
  },
  {
    "title": "Panch Ganga Temple",
    "description": "The Panch Ganga Temple is believed to be the confluence of five rivers—Krishna, Venna, Savitri, Koyna, and Gayatri. Built in the 13th century, it holds immense religious importance. Pilgrims visit to take blessings at the sacred water source. The temple’s historical architecture adds to its charm. It is a significant spiritual stop in Mahabaleshwar. The site blends mythology, heritage, and devotion."
  },
  {
    "title": "Connaught Peak",
    "description": "Connaught Peak, formerly known as Mount Olympia, is the second-highest point in Mahabaleshwar. It offers panoramic views of Venna Lake, Krishna Valley, and Pratapgad Fort. The peak is popular for trekking, photography, and sunset watching. It is less crowded compared to other viewpoints, making it peaceful. Couples and families enjoy its quiet charm. Connaught Peak is a serene destination for scenic lovers."
  }
],

"services": [
    {
        "name": "Pune to Mahabaleshwar Outstation Swift Taxi Fare",
        "description": "Get the most affordable Swift Dzire taxi fare for outstation travel from Pune to Mahabaleshwar. Our service includes comfortable seating, expert drivers, and transparent per km pricing ideal for solo travelers, couples, or small families."
    },
    {
        "name": "Pune to Mahabaleshwar Swift Dzire Package",
        "description": "Book our Pune to Mahabaleshwar Swift Dzire cab package for a budget-friendly and relaxing hill station getaway. The package includes fuel, driver allowance, tolls, and return fare—no hidden charges and flexible travel plans."
    },
    {
        "name": "Swift Dzire Rent per km Rate",
        "description": "Explore affordable Swift Dzire rental rates per km for local and outstation trips. Whether it’s a short ride or a weekend journey, enjoy competitive pricing, clean cars, and professional drivers with on-time service."
    },
    {
        "name": "Swift Dzire per km Rate",
        "description": "Our Swift Dzire per km rate is designed for those who seek both comfort and economy. Ideal for outstation travel, this pricing model ensures you pay only for the distance traveled with no unnecessary extras."
    },
    {
        "name": "Best Sedan Cab Service in Pune",
        "description": "Choose the best-rated sedan cab service in Pune for local, airport, and long-distance travel. Enjoy a fleet of well-maintained Dzire and Etios cars with reliable drivers and 24/7 support for a seamless travel experience."
    },
    {
        "name": "Best Sedan Cab for Pune to Mahabaleshwar",
        "description": "Our Swift Dzire is the preferred sedan cab for travelers from Pune to Mahabaleshwar. Offering great mileage, AC comfort, and smooth rides through the ghats, it’s perfect for couples, families, or corporate clients."
    },
    {
        "name": "Pune to Mahabaleshwar Dzire Taxi Booking",
        "description": "Easily book a Dzire taxi from Pune to Mahabaleshwar online or over the phone. Enjoy door-to-door pickup, courteous drivers, and well-maintained cars at the best rates with no last-minute surprises."
    },
    {
        "name": "Pune to Mahabaleshwar Swift Dzire Round Trip",
        "description": "Book a Swift Dzire round trip from Pune to Mahabaleshwar for a relaxing weekend or day tour. Our round-trip plan includes return fare, professional chauffeurs, and convenient timing to suit your itinerary."
    },
    {
        "name": "Affordable Dzire Pune to Mahabaleshwar",
        "description": "Our affordable Dzire cab service from Pune to Mahabaleshwar is perfect for budget-conscious travelers. Enjoy a comfortable ride in an AC sedan with low fares, punctual service, and experienced drivers."
    },
    {
        "name": "Luxury Dzire Pune to Mahabaleshwar",
        "description": "Experience a premium journey from Pune to Mahabaleshwar in our luxury Swift Dzire cabs. Ideal for couples or executives seeking comfort, style, and smooth service with premium interiors and top-rated chauffeurs."
    }
],
"tableData": [
    ["Pune to Mahabaleshwar Outstation Swift Taxi Fare", "Pune to Mahabaleshwar Swift Dzire Package"],
    ["Swift Dzire Rent per km Rate", "Swift Dzire per km Rate"],
    ["Best Sedan Cab Service in Pune", "Best Sedan Cab for Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Dzire Taxi Booking", "Pune to Mahabaleshwar Swift Dzire Round Trip"],
    ["Affordable Dzire Pune to Mahabaleshwar", "Luxury Dzire Pune to Mahabaleshwar"]
],


"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Mahabaleshwar Swift Dzire Cab Service",
        "WhyChoosedescription": "Prince Cabs provides reliable Swift Dzire cab services from Pune to Mahabaleshwar, perfect for families, friends, and couples planning a relaxing hill station getaway. The Swift Dzire combines fuel efficiency with comfortable seating and smooth suspension, making your 3-4 hour drive to Mahabaleshwar pleasant and stress-free."
    },
    {
        "WhyChooseheading": "Spacious and Clean Interiors for a Relaxing Journey",
        "WhyChoosedescription": "Our Swift Dzire vehicles feature well-maintained, clean cabins with ergonomic seating for up to four passengers and ample luggage space for your bags. The air-conditioned interiors ensure comfort throughout the drive, whether you’re traveling during summer or monsoon seasons."
    },
    {
        "WhyChooseheading": "Skilled Drivers with Local Route Expertise",
        "WhyChoosedescription": "Our experienced drivers know the best routes from Pune to Mahabaleshwar, avoiding traffic and taking scenic byways when possible. They drive safely on hilly terrains and ensure timely pickups and drop-offs, allowing you to enjoy the journey as much as the destination."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
        "WhyChoosedescription": "Whether you need a one-way trip to Mahabaleshwar or a round-trip package with a comfortable waiting period, Prince Cabs offers flexible rental options tailored to your schedule. Book via phone, WhatsApp, or online with easy cancellations and instant confirmations."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Our Pune to Mahabaleshwar Swift Dzire cab service comes with transparent, competitive pricing that includes fuel, tolls, driver allowances, and taxes. You’ll receive a clear fare estimate upfront, with payment options including UPI, credit/debit cards, net banking, and cash."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Safety",
        "WhyChoosedescription": "Each Swift Dzire cab is thoroughly cleaned and sanitized before every trip, ensuring your health and safety. Regular maintenance checks guarantee mechanical reliability and a safe, comfortable ride to Mahabaleshwar’s picturesque hills."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
        "WhyChoosedescription": "Our customer care team is available around the clock to assist with bookings, itinerary changes, or any travel-related queries. With Prince Cabs, enjoy a worry-free travel experience from Pune to Mahabaleshwar in your Swift Dzire."
    }
]


























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Swift Dzire cab service from Pune to Mahabaleshwar?',
        answer: 'Yes, Prince Cabs offers comfortable and reliable Swift Dzire cabs for travel from Pune to Mahabaleshwar, perfect for family trips and weekend getaways.',
    },
    {
        question: 'What is the fare for Pune to Mahabaleshwar Swift Dzire cab?',
        answer: 'The fare typically starts from ₹3,500 for a one-way trip. Prices may vary depending on the travel date, time, and any additional stops.',
    },
    {
        question: 'How long does it take to travel from Pune to Mahabaleshwar by Swift Dzire?',
        answer: 'The journey takes approximately 3.5 to 4 hours, depending on traffic and road conditions on the way.',
    },
    {
        question: 'Is the Swift Dzire suitable for hill station travel like Mahabaleshwar?',
        answer: 'Yes, the Swift Dzire is fuel-efficient, comfortable, and well-suited for the winding roads leading to Mahabaleshwar.',
    },
    {
        question: 'Can I book a round-trip Swift Dzire cab for Pune to Mahabaleshwar?',
        answer: 'Absolutely! We offer flexible round-trip and one-way packages with options for same-day return or overnight stays.',
    },
    {
        question: 'Are Swift Dzire cabs sanitized and well-maintained for such trips?',
        answer: 'Yes, all our Swift Dzire cabs are thoroughly cleaned and sanitized before every journey to ensure passenger safety and comfort.',
    },
    {
        question: 'How do I book a Pune to Mahabaleshwar Swift Dzire cab?',
        answer: 'Booking is easy through our website or by calling Prince Cabs directly. Provide your travel details and we’ll arrange your cab promptly.',
    },
];

const testimonials = [
    {
        name: "Mr. Akash Patil",
        position: "Family Traveler",
        text: "We had a great experience traveling from Pune to Mahabaleshwar in a Swift Dzire cab. The car was clean, and the driver was very courteous.",
        image: "/img/testimonial/testimonial-thumb-mahabaleshwar-1.png",
    },
    {
        name: "Ms. Sneha Joshi",
        position: "Weekend Traveler",
        text: "Prince Cabs made our Pune to Mahabaleshwar trip easy and comfortable with their Swift Dzire service. Highly recommend their cabs!",
        image: "/img/testimonial/testimonial-thumb-mahabaleshwar-2.png",
    },
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mahabaleshwar Swift Dzire Cabs",
  "description": "Affordable and reliable Swift Dzire taxi service from Pune to Mahabaleshwar including outstation fares, round trips, and luxury sedan options.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Mahabaleshwar Outstation Swift Taxi Fare",
    "Pune to Mahabaleshwar Swift Dzire Package",
    "Swift Dzire Rent per km Rate",
    "Swift Dzire per km Rate",
    "Best Sedan Cab Service in Pune",
    "Best Sedan Cab for Pune to Mahabaleshwar",
    "Pune to Mahabaleshwar Dzire Taxi Booking",
    "Pune to Mahabaleshwar Swift Dzire Round Trip",
    "Affordable Dzire Pune to Mahabaleshwar",
    "Luxury Dzire Pune to Mahabaleshwar"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Mahabaleshwar Swift Dzire Cabs | Affordable Sedan Taxi Service</title>
  <meta
    name="description"
    content="Affordable and reliable Swift Dzire taxi service from Pune to Mahabaleshwar including outstation fares, round trips, and luxury sedan options."
  />
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Outstation Swift Taxi Fare, Pune to Mahabaleshwar Swift Dzire Package, Swift Dzire Rent per km Rate, Swift Dzire per km Rate, Best Sedan Cab Service in Pune, Best Sedan Cab for Pune to Mahabaleshwar, Pune to Mahabaleshwar Dzire Taxi Booking, Pune to Mahabaleshwar Swift Dzire Round Trip, Affordable Dzire Pune to Mahabaleshwar, Luxury Dzire Pune to Mahabaleshwar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwarswift ;